export default "__VITE_ASSET__faa47689__"